/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_Three_SecondsInputs */

const en_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back three second in the video`)
};

const fr_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reculer de trois secondes dans la video`)
};

const de_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spule im Video drei Sekunden zurück.`)
};

const it_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna indietro di tre secondi nel video`)
};

const ru_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернитесь на три секунды назад в видео.`)
};

const es_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceda tres segundos en el vídeo.`)
};

const zh_cn2_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频倒回三秒处。`)
};

const ja_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画を3秒前に戻します`)
};

const hi_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में तीन सेकंड पीछे जाइए।`)
};

const pt_pt2_shortcut_keys_desc_reverse_three_seconds = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte três segundos no vídeo.`)
};

/**
* | output |
* | --- |
* | "Go back three second in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_Three_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_three_seconds = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_Three_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "de") return de_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "it") return it_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "es") return es_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_reverse_three_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_reverse_three_seconds(inputs)
	return en_shortcut_keys_desc_reverse_three_seconds(inputs)
});